import { put } from "@redux-saga/core/effects";
import { addBulkOptionsRequest } from "../actionCreaters";

import { DuplicateOptionsActionType, IBulkOptions } from "./../types";

export function* duplicateOptionsSaga({ payload: { fieldId, options } }: DuplicateOptionsActionType) {
    try {
        const duplicatedOptions: IBulkOptions = {
            label: Object.keys(options).map(optionId => {
                return options[optionId].label;
            }),
        };

        yield put(addBulkOptionsRequest({ fieldId, options: duplicatedOptions }));
    } catch (error) {}
}
